import React from 'react';
import { Switch } from 'react-router';
import { Route } from 'react-router-dom';

import { DepositWizard } from '@swf/first';

import FirstRoute from './FirstRoute';

const DepositRoute: React.FC = () => (
  <Switch>
    <Route
      path="/deposit/result" // paycallback url : no need to do login
      render={() => <FirstRoute component={DepositWizard} noCache requireAuth={false} />}
    />
    <Route path="/deposit" render={() => <FirstRoute component={DepositWizard} noCache />} />
  </Switch>
);

export default DepositRoute;
